var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiBellFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:bell-fill",
    clipPath: "url(#clip0_769_678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 16.0009C8.53043 16.0009 9.03914 15.7902 9.41421 15.4151C9.78929 15.04 10 14.5313 10 14.0009H6C6 14.5313 6.21071 15.04 6.58579 15.4151C6.96086 15.7902 7.46957 16.0009 8 16.0009ZM8.995 1.09987C9.00896 0.960829 8.99362 0.820401 8.94997 0.687648C8.90632 0.554895 8.83533 0.432765 8.74158 0.329133C8.64783 0.225501 8.5334 0.142669 8.40567 0.0859795C8.27794 0.0292895 8.13974 0 8 0C7.86026 0 7.72206 0.0292895 7.59433 0.0859795C7.4666 0.142669 7.35217 0.225501 7.25842 0.329133C7.16467 0.432765 7.09368 0.554895 7.05003 0.687648C7.00638 0.820401 6.99104 0.960829 7.005 1.09987C5.87472 1.32978 4.85862 1.94324 4.12876 2.83638C3.39891 3.72952 3.00015 4.84745 3 6.00087C3 7.09888 2.5 12.0009 1 13.0009H15C13.5 12.0009 13 7.09888 13 6.00087C13 3.58087 11.28 1.56087 8.995 1.09987Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiBellFill);
export default __webpack_public_path__ + "static/media/bi_bell-fill.5b51c6834b5876d5ac794c20598c21a6.svg";
export { ForwardRef as ReactComponent };